import styles from '../../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div
      id='libraryCustomersFolderPreview'
      role='dialog'
      onKeyDown={(e) => e.stopPropagation()}
      className={styles.template_preview_container}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <p id='libraryCustomersFolderPreviewText'>
        The Customers Folder helps small businesses manage client interactions and protect revenue
        with clear, compliant documentation. These tools reduce miscommunication, prevent legal
        disputes, and streamline payments. By using these documents consistently, businesses can
        protect themselves from liability, strengthen relationships, and ensure smooth financial
        operations.
      </p>
    </div>
  );
};

export default Preview;
